module.exports = __webpack_public_path__ + "img/08.5d5a9e0e.png";